const en_abilities = {
  flm_rs      : 'Flame Res',
  wtr_rs      : 'Water Res',
  wnd_rs      : 'Wind Res',
  lgh_rs      : 'Light Res',
  shd_rs      : 'Shadow Res',

  afl_grd     : 'Affliction Guard',
  psn_rs      : 'Poision Res',
  brn_rs      : 'Burn Res',
  frz_rs      : 'Freeze Res',
  prl_rs      : 'Paralysis Res',
  bln_rs      : 'Blindness Res',
  stn_rs      : 'Stun Res',
  crs_rs      : 'Curse Res',
  bg_rs       : 'Bog Res',
  slp_rs      : 'Sleep Res',

  hmd_rs      : 'High Midgardsormr Res',
  md_rs       : 'Midgardsormr Res',
  hbr_rs      : 'High Brunhilda Res',
  br_rs       : 'Brunhilda Res',
  hmr_rs      : 'High Mercury Res',
  mr_rs       : 'Mercury Res',
  hjp_rs      : 'High Jupiter Res',
  jp_rs       : 'Jupiter Res',
  hzd_rs      : 'High Zodiark Res',
  zd_rs       : 'Zodiark Res',

  hfl_str     : 'Full HP = Strength',
  hfl_dfn     : 'Full HP = Defense',
  hfl_hl      : 'Full HP = Healing',
  hfl_skl_dmg : 'Full HP = Skill Damage',
  hfl_crt_rt  : 'Full HP = Critical Rate',
  hfl_crt_dmg : 'Full HP = Critical Damage',

  h70_str     : 'HP 70% = Strength',
  h70_dfn     : 'HP 70% = Defense',
  h70_hl      : 'HP 70% = Healing',
  h70_skl_dmg : 'HP 70% = Skill Damage',
  h70_crt_rt  : 'HP 70% = Critical Rate',
  h70_crt_dmg : 'HP 70% = Critical Damage',

  str_dbb     : 'Strength Doublebuff',
  hl_dbb      : 'Healing Doublebuff',
  enr_dbb     : 'Energy Doublebuff',
  crt_dmg_dbb : 'Critical Damage Doublebuff',

  lst_ofn     : 'Last Offense',
  lst_dfn     : 'Last Defense',
  lst_rcv     : 'Last Recovery',
  lst_crt_rt  : 'Last Devastation',
  rsl_ofn     : 'Resilient Offense',

  flr_str     : 'Flurry Strength',
  flr_dvs     : 'Flurry Devastation',
  hts_elu     : 'Hits = Energy Level Up',

  drg_dmg     : 'Dragon Damage',
  drg_tm      : 'Dragon Time',
  drg_clw     : 'Dragon\'s Claws',

  skl_prp     : 'Skill Prep',
  shs_prp     : 'Shapeshift Prep',
  enr_prp     : 'Energy Prep',
  shl_prp     : 'Shield Prep',

  skl_hst     : 'Skill Haste',
  unt_hst     : 'United Haste',
  stk_hst     : 'Striking Haste',

  frc_stk     : 'Force Strike',
  frc_chr     : 'Force Charge',

  ovd_pns     : 'Overdrive Punisher',
  brk_pns     : 'Broken Punisher',
  brn_pns     : 'Burning Punisher',
  psn_pns     : 'Poision Punisher',
  frz_pns     : 'Freeze Punisher',
  prl_pns     : 'Paralysis Punisher',
  bln_pns     : 'Blindness Punisher',
  stn_pns     : 'Stun Punisher',
  crs_pns     : 'Curse Punisher',
  bg_pns      : 'Bog Punisher',
  slp_pns     : 'Sleep Punisher',

  slyr_str    : 'Slayer\'s Strength',
  stkr_str    : 'Striker\'s Strength',

  gg_acl      : 'Gauge Accelerator',
  gg_inh      : 'Gauge Inhibitor',

  hp          : 'HP',
  skl_dmg     : 'Skill Damage',
  crt_rt      : 'Critical Rate',
  crt_dmg     : 'Critical Damage',
  rcv_ptn     : 'Recovery Potency',
  bf_tm       : 'Buff Time',

  exp_1       : 'Happy Dragonyule!',
  exp_2       : 'Loving Heart',
  exp_3       : 'A Song That Envelops the World',
}

export default en_abilities